import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../../../types/results';
import { getAllProducs } from '../../../../utils/trackings';

export function trackCreateFolder(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_collection',
    label: 'main_block',
    products,
  });
}
